import React from 'react';

import { colors, typography } from '@pray/shared/components/foundations';
import Text from '@pray/shared/components/ui/Text';
import { cn } from '@pray/shared/utils/styles';

import type { PriceDisplayProps } from '../types';

import styles from './PriceDisplay.module.scss';

export default function PriceDisplay({ amount, period, description, className }: PriceDisplayProps) {
  return (
    <div className={cn(styles.priceDisplay, className)}>
      <div className={styles.headline}>
        <Text variant={typography.heading_4xl} color={colors.text_featured}>
          {amount}
        </Text>
        {period && <Text className={styles.period}>{period}</Text>}
      </div>
      {description && (
        <Text variant={typography.body_md} className={styles.description}>
          {description}
        </Text>
      )}
    </div>
  );
}
